<template>
  <el-dialog
    append-to-body
    width="500px"
    title="修改五险缴纳档次"
    center
    :visible.sync="visible"
    :before-close="reset"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-form
      v-loading="loading"
      element-loading-text="加载中…"
      ref="elFormDom"
      label-width="130px"
      label-position="right"
      :model="form.data"
      :rules="form.rules"
      :size="subUnitSize"
    >
      <el-form-item label="已选员工：">
        <span>{{ listInfo.length }}人</span>
      </el-form-item>
      <el-form-item prop="insurance_level_id" label="五险档次：">
        <el-select
          v-model="form.data.insurance_level_id"
          placeholder="请选择五险档次"
          clearable
          filterable
        >
          <el-option
            v-for="item in typeOpt"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
            <span style="float: left">{{ item.name }}</span>
            <span style="float: right; color: #8492a6; font-size: 13px">{{ item.invoice_company_name }}</span>
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="pay_type" label="缴纳方式：">
        <el-select
          v-model="form.data.pay_type"
          placeholder="请选择缴纳方式"
          clearable
          filterable
        >
          <el-option label="单位全额" :value="1"></el-option>
          <el-option label="员工全额" :value="2"></el-option>
          <el-option label="单位员工各自缴纳" :value="3"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <template #footer>
      <el-row type="flex" justify="center">
        <el-button @click="toggle(false)">取消</el-button>
        <el-button
          type="primary"
          :loading="form.loading"
          :disabled="form.loading"
          @click="confirm"
          >确定</el-button
        >
      </el-row>
    </template>
  </el-dialog>
</template>
<script>
import {getStorage} from '@/storage'
export default {
  data() {
    return {
      invoice_company_id:Number(getStorage('icId')),
      listInfo: [],
      subUnitSize: this.$store.state.subUnitSize, // 获取组件 size属性
      visible: false,
      isChange: false,
      loading: false,
      typeOpt: [],
      form: {
        loading: false,
        data: {
          insurance_level_id: "",
          pay_type: "",
        },
        rules: {
          insurance_level_id: [
            { required: true, message: "必填", trigger: "change" },
          ],
          pay_type: [{ required: true, message: "必填", trigger: "change" }],
        },
      },
    };
  },
  mounted() {
    this.typeOptGet();
  },
  methods: {
    typeOptGet() {
      this.$http
        .post("/admin/InsuranceLevel/list", {is_all: 1,invoice_company_id:this.invoice_company_id} )
        .then((res) => {
          if (res.code === 1) {
            this.typeOpt = res.data.list;
          }
        });
    },
    // 获取组织详情
    getDetail(list) {
      this.listInfo = list;
    },
    reset(done) {
      this.isChange = false;
      this.$refs.elFormDom.resetFields();
      done && done();
    },
    toggle(show) {
      this.visible = show;
      !show && this.reset();
    },
    // 提交
    confirm() {
      this.$refs.elFormDom.validate((valid) => {
        if (valid) {
          let params = {
            ids: this.listInfo.map(item => item.id).join(','),
            insurance_level_id: this.form.data.insurance_level_id,
            pay_type: this.form.data.pay_type,
          };
          this.form.loading = true;
          this.$http
            .post("/admin/employee/changeInsuranceLevel", params)
            .then((res) => {
              if (res.code === 1) {
                this.$message.success("操作成功！");
                this.toggle(false);
                this.$emit("refresh");
              } else {
                this.$message.error(res.msg);
              }
            }).finally(() => {
              this.form.loading = false;
            })
        }
      });
    },
  },
};
</script>